import { inheritsLoose as _inheritsLoose } from './_virtual/_rollupPluginBabelHelpers.js';
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-final-form';
import EmailPasswordSocialNewslettersLogin from './EmailPasswordSocialNewslettersLogin/index.js';
import TextSignup from './TextSignup/index.js';
import CustomFields from './CustomFields/index.js';
import Newsletters from './Newsletters/index.js';
import Success from './Success/index.js';
import { EmailIconToggle, SMSIconToggle, EmailToggle, SMSToggle } from './icons.js';
import cx from 'classnames';
import styles from './scss/Signup.module.scss.js';

var ErrorBoundary = /*#__PURE__*/function (_React$Component) {
  _inheritsLoose(ErrorBoundary, _React$Component);
  ErrorBoundary.getDerivedStateFromError = function getDerivedStateFromError(error) {
    console.log('getDerivedStateFromError', error);
    return {
      hasError: true
    };
  };
  function ErrorBoundary(props) {
    var _this;
    _this = _React$Component.call(this, props) || this;
    _this.state = {
      hasError: false
    };
    return _this;
  }
  var _proto = ErrorBoundary.prototype;
  _proto.componentDidCatch = function componentDidCatch(error, errorInfo) {
    console.error(error.message, errorInfo);
  };
  _proto.render = function render() {
    var hasError = this.state.hasError;
    var _this$props = this.props,
      children = _this$props.children,
      _this$props$RenderErr = _this$props.RenderError,
      RenderError = _this$props$RenderErr === void 0 ? function () {
        return /*#__PURE__*/React.createElement("div", {
          className: "errorBoundaree"
        });
      } : _this$props$RenderErr;
    if (hasError) {
      return /*#__PURE__*/React.createElement(RenderError, null);
    }
    return children;
  };
  return ErrorBoundary;
}(React.Component);
var TabIcons = {
  email: EmailIconToggle,
  sms: SMSIconToggle
};
var TabIconsWithText = {
  email: EmailToggle,
  sms: SMSToggle
};
var Signup = function Signup(_temp) {
  var _ref2, _cx, _cx2, _cx4, _cx5, _cx6;
  var _ref = _temp === void 0 ? {} : _temp,
    checkPhone = _ref.checkPhone,
    children = _ref.children,
    confirmCode = _ref.confirmCode,
    contrastColor = _ref.contrastColor,
    fieldContainerProps = _ref.fieldContainerProps,
    isReturningUser = _ref.isReturningUser,
    _ref$linkColor = _ref.linkColor,
    linkColor = _ref$linkColor === void 0 ? '' : _ref$linkColor,
    _ref$onSubmitCallback = _ref.onSubmitCallback,
    onSubmitCallback = _ref$onSubmitCallback === void 0 ? function () {} : _ref$onSubmitCallback,
    phoneNumber = _ref.phoneNumber,
    _ref$previewMode = _ref.previewMode,
    previewMode = _ref$previewMode === void 0 ? false : _ref$previewMode,
    oneTimeCodeError = _ref.oneTimeCodeError,
    _ref$oneTimeCodeSent = _ref.oneTimeCodeSent,
    oneTimeCodeSent = _ref$oneTimeCodeSent === void 0 ? false : _ref$oneTimeCodeSent,
    subtitle = _ref.subtitle,
    username = _ref.username,
    userPhoneMismatchError = _ref.userPhoneMismatchError,
    access_token = _ref.access_token,
    _ref$authenticationMe = _ref.authenticationMethods,
    authenticationMethods = _ref$authenticationMe === void 0 ? [] : _ref$authenticationMe,
    checkEmail = _ref.checkEmail,
    _ref$customFieldsVali = _ref.customFieldsValid,
    customFieldsValid = _ref$customFieldsVali === void 0 ? function () {
      return true;
    } : _ref$customFieldsVali,
    email = _ref.email,
    isPaymentLandingPage = _ref.isPaymentLandingPage,
    isNewRegistration = _ref.isNewRegistration,
    _ref$name = _ref.name,
    name = _ref$name === void 0 ? 'signup' : _ref$name,
    _ref$newsletters = _ref.newsletters,
    newsletters = _ref$newsletters === void 0 ? [] : _ref$newsletters,
    onSocialLogin = _ref.onSocialLogin,
    origin = _ref.origin,
    popupId = _ref.popupId,
    publisherId = _ref.publisherId,
    resendOneTimeCode = _ref.resendOneTimeCode,
    resetOneTimeCode = _ref.resetOneTimeCode,
    _ref$showError = _ref.showError,
    showError = _ref$showError === void 0 ? false : _ref$showError,
    _ref$showTerms = _ref.showTerms,
    showTerms = _ref$showTerms === void 0 ? false : _ref$showTerms,
    onSkipOtp = _ref.onSkipOtp,
    _ref$updateAccountErr = _ref.updateAccountError,
    updateAccountError = _ref$updateAccountErr === void 0 ? {} : _ref$updateAccountErr,
    userId = _ref.userId,
    utm = _ref.utm,
    defaultType = _ref.defaultType,
    customFields = _ref.customFields,
    _ref$isAuthed = _ref.isAuthed,
    isAuthed = _ref$isAuthed === void 0 ? {
      email: false,
      sms: false
    } : _ref$isAuthed,
    _ref$setFlow = _ref.setFlow,
    setFlow = _ref$setFlow === void 0 ? function () {} : _ref$setFlow,
    _ref$markDown = _ref.markDown,
    markDown = _ref$markDown === void 0 ? function () {
      return null;
    } : _ref$markDown,
    _ref$errorMessage = _ref.errorMessage,
    errorMessage = _ref$errorMessage === void 0 ? {} : _ref$errorMessage,
    loginRedirect = _ref.loginRedirect,
    loginPhone = _ref.loginPhone,
    _ref$userEmail = _ref.userEmail,
    userEmail = _ref$userEmail === void 0 ? '' : _ref$userEmail,
    _ref$userPhone = _ref.userPhone,
    userPhone = _ref$userPhone === void 0 ? '' : _ref$userPhone,
    _ref$manageAccount = _ref.manageAccount,
    manageAccount = _ref$manageAccount === void 0 ? function () {} : _ref$manageAccount,
    showSignupIcons = _ref.showSignupIcons;
  var form = useForm();
  var values = form.getState().values;
  var isCustomFieldsValid = (_ref2 = customFieldsValid() || isAuthed.email || isAuthed.sms) !== null && _ref2 !== void 0 ? _ref2 : false;
  var isAuthenticated = (isAuthed === null || isAuthed === void 0 ? void 0 : isAuthed.email) || (isAuthed === null || isAuthed === void 0 ? void 0 : isAuthed.sms);
  var tabs = [].concat(authenticationMethods.includes('sms') ? ['sms'] : [], authenticationMethods.includes('email') || authenticationMethods.includes('facebook') || authenticationMethods.includes('twitter') || authenticationMethods.includes('github') || authenticationMethods.includes('linkedin') || authenticationMethods.includes('google') ? ['email'] : []);
  var _useState = useState((defaultType === null || defaultType === void 0 ? void 0 : defaultType.flow) || (defaultType === null || defaultType === void 0 ? void 0 : defaultType.type) || tabs[0]),
    currTab = _useState[0],
    setCurrTab = _useState[1];
  useEffect(function () {
    if (previewMode) {
      setCurrTab((defaultType === null || defaultType === void 0 ? void 0 : defaultType.type) || tabs[0]);
    }
  }, [JSON.stringify(tabs), previewMode, defaultType === null || defaultType === void 0 ? void 0 : defaultType.type]);
  var getErrorText = function getErrorText(text) {
    var texts = {
      login: 'Please log in instead.',
      signup: 'Please sign up instead.'
    };
    var result = text;

    // replacing instances of Please log in or sign up with HTML element
    var type = text.includes(texts['login']) ? 'login' : text.includes(texts['signup']) ? 'signup' : null;
    if (loginRedirect && type) {
      var splitText = result.split(texts[type])[0];
      result = /*#__PURE__*/React.createElement("span", null, splitText, 'Please ', /*#__PURE__*/React.createElement("span", {
        className: styles.redirectText,
        onClick: function onClick() {
          return loginRedirect(type);
        }
      }, type === 'login' ? 'log in' : 'sign up'), ' instead.');
    }
    return result;
  };
  var NewsletterSignupProps = {
    access_token: access_token,
    authenticationMethods: authenticationMethods,
    checkEmail: checkEmail,
    confirmCode: confirmCode,
    contrastColor: contrastColor,
    isCustomFieldsValid: isCustomFieldsValid,
    values: values,
    email: email,
    fieldContainerProps: fieldContainerProps,
    isPaymentLandingPage: isPaymentLandingPage,
    isNewRegistration: isNewRegistration,
    isReturningUser: isReturningUser,
    linkColor: linkColor,
    name: name,
    newsletters: newsletters,
    oneTimeCodeError: oneTimeCodeError,
    oneTimeCodeSent: oneTimeCodeSent,
    onSocialLogin: onSocialLogin,
    onSubmitCallback: onSubmitCallback,
    origin: origin,
    popupId: popupId,
    previewMode: previewMode,
    publisherId: publisherId,
    resendOneTimeCode: resendOneTimeCode,
    resetOneTimeCode: resetOneTimeCode,
    showError: showError,
    showTerms: showTerms,
    onSkipOtp: onSkipOtp,
    updateAccountError: updateAccountError,
    userId: userId,
    username: username,
    utm: utm,
    setFlow: setFlow,
    errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.email,
    getErrorText: getErrorText,
    isAuthenticated: isAuthenticated
  };
  var TextSignupProps = {
    checkPhone: checkPhone,
    confirmCode: confirmCode,
    contrastColor: contrastColor,
    fieldContainerProps: fieldContainerProps,
    isReturningUser: isReturningUser,
    linkColor: linkColor,
    oneTimeCodeError: oneTimeCodeError,
    oneTimeCodeSent: oneTimeCodeSent,
    onSubmitCallback: onSubmitCallback,
    phoneNumber: phoneNumber,
    previewMode: previewMode,
    username: username,
    userPhoneMismatchError: userPhoneMismatchError,
    values: values,
    defaultType: defaultType,
    isCustomFieldsValid: isCustomFieldsValid,
    setFlow: setFlow,
    resetOneTimeCode: resetOneTimeCode,
    errorMessage: errorMessage === null || errorMessage === void 0 ? void 0 : errorMessage.phone,
    getErrorText: getErrorText,
    loginPhone: loginPhone,
    isAuthenticated: isAuthenticated
  };
  if (!tabs.length) {
    return null;
  }
  var richTextRegex = /(.*?)customtext(.*?)pico.tools(.*?)+/g;
  var isSubTitleRichText = !!(subtitle || '').match(richTextRegex);
  var hasTabs = tabs.length > 1;
  var hasNewsletters = !!newsletters.length;
  var hasCustomFields = !!customFields.length;
  return /*#__PURE__*/React.createElement(ErrorBoundary, null, /*#__PURE__*/React.createElement("div", {
    className: styles.container
  }, (!!((hasTabs || subtitle || hasNewsletters || hasCustomFields) && !oneTimeCodeSent) || !!(subtitle && oneTimeCodeSent)) && /*#__PURE__*/React.createElement("div", {
    className: styles.header_container
  }, !isSubTitleRichText && subtitle && /*#__PURE__*/React.createElement("p", {
    className: styles.subtitle
  }, subtitle), isSubTitleRichText && subtitle && (markDown === null || markDown === void 0 ? void 0 : markDown()), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.unvisible, (_cx = {}, _cx[styles.visible] = !oneTimeCodeSent, _cx))
  }, /*#__PURE__*/React.createElement(React.Fragment, null, hasCustomFields && !isReturningUser && !isAuthenticated && /*#__PURE__*/React.createElement(CustomFields, {
    fields: customFields,
    linkColor: linkColor
  }), hasNewsletters && !isReturningUser && !isAuthenticated && /*#__PURE__*/React.createElement(Newsletters, {
    linkColor: linkColor,
    previewMode: previewMode,
    newsletters: newsletters
  }), hasTabs && /*#__PURE__*/React.createElement("div", {
    className: cx(styles.tabs, (_cx2 = {}, _cx2[styles['tabs--authed']] = isAuthenticated, _cx2[styles['showSignupIcons']] = showSignupIcons, _cx2)),
    "data-testid": "toggle"
  }, tabs.map(function (tab, idx) {
    var _cx3;
    return /*#__PURE__*/React.createElement("div", {
      key: tab + "-" + idx,
      className: cx(styles.tab, (_cx3 = {}, _cx3[styles['tab--active']] = currTab === tab, _cx3)),
      onClick: function onClick() {
        return setCurrTab(tab);
      }
    }, showSignupIcons ? TabIcons[tab]() : /*#__PURE__*/React.createElement("div", {
      className: styles.iconWithText
    }, TabIconsWithText[tab]()), currTab === tab && /*#__PURE__*/React.createElement("div", {
      className: styles.triangle
    }));
  }))))), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.signup_container, (_cx4 = {}, _cx4[styles.otp_container] = oneTimeCodeSent, _cx4[styles.showSignupIcons] = showSignupIcons, _cx4))
  }, /*#__PURE__*/React.createElement("div", {
    className: cx(styles.unvisible, (_cx5 = {}, _cx5[styles.visible] = currTab === 'email', _cx5))
  }, isAuthed !== null && isAuthed !== void 0 && isAuthed.email ? /*#__PURE__*/React.createElement(Success, {
    email: userEmail,
    contrastColor: contrastColor,
    onClick: manageAccount
  }) : /*#__PURE__*/React.createElement(EmailPasswordSocialNewslettersLogin, NewsletterSignupProps)), /*#__PURE__*/React.createElement("div", {
    className: cx(styles.unvisible, (_cx6 = {}, _cx6[styles.visible] = currTab === 'sms', _cx6))
  }, isAuthed !== null && isAuthed !== void 0 && isAuthed.sms ? /*#__PURE__*/React.createElement(Success, {
    phone: userPhone,
    contrastColor: contrastColor,
    onClick: manageAccount
  }) : /*#__PURE__*/React.createElement(TextSignup, TextSignupProps))), children && !isAuthenticated && /*#__PURE__*/React.createElement("div", {
    className: styles.loginText
  }, children)));
};
Signup.defaultProps = {
  customFields: []
};
Signup.propTypes = {
  access_token: PropTypes.string,
  authenticationMethods: PropTypes.array,
  checkEmail: PropTypes.func,
  checkPhone: PropTypes.func,
  children: PropTypes.object,
  confirmCode: PropTypes.func,
  contrastColor: PropTypes.string,
  customFields: PropTypes.array,
  customFieldsValid: PropTypes.func,
  defaultType: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.string,
  email: PropTypes.string,
  errorMessage: PropTypes.object,
  fieldContainerProps: PropTypes.any,
  hasUserLoader: PropTypes.bool,
  isAuthed: PropTypes.object,
  isNewRegistration: PropTypes.bool,
  isPaymentLandingPage: PropTypes.bool,
  isReturningUser: PropTypes.bool,
  linkColor: PropTypes.string,
  loginPhone: PropTypes.any,
  loginRedirect: PropTypes.func,
  manageAccount: PropTypes.func,
  markDown: PropTypes.func,
  name: PropTypes.string,
  newsletters: PropTypes.array,
  oneTimeCodeError: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  oneTimeCodeSent: PropTypes.bool,
  onSkipOtp: PropTypes.func,
  onSocialLogin: PropTypes.func,
  onSubmitCallback: PropTypes.func,
  origin: PropTypes.string,
  phoneNumber: PropTypes.string,
  popupId: PropTypes.string,
  previewMode: PropTypes.bool,
  publisherId: PropTypes.string,
  required: PropTypes.bool,
  resendOneTimeCode: PropTypes.func,
  resetOneTimeCode: PropTypes.func,
  setFlow: PropTypes.func,
  showError: PropTypes.bool,
  showSignupIcons: PropTypes.bool,
  showTerms: PropTypes.bool,
  subtitle: PropTypes.string,
  title: PropTypes.string,
  updateAccountError: PropTypes.object,
  userEmail: PropTypes.string,
  userId: PropTypes.string,
  username: PropTypes.string,
  userPhone: PropTypes.string,
  userPhoneMismatchError: PropTypes.string,
  utm: PropTypes.string
};
var MemoizedSignup = /*#__PURE__*/React.memo(Signup);
MemoizedSignup.displayName = 'FieldSignup';

export { MemoizedSignup as default };
//# sourceMappingURL=index.js.map
